import React from "react";
import Block from "../Block";
import { classes } from "../utils/classes";

const Content = ({ children, className = "", ...props }) => (
	<Block className={classes("square__content", className)} {...props}>
		{children}
	</Block>
);

Content.propTypes = {
	...Block.propTypes,
};

const Square = ({ children, className = "", ...props }) => (
	<Block className={classes("square", className)} {...props}>
		{children}
	</Block>
);

Square.propTypes = {
	...Block.propTypes,
};

Square.Content = Content;

export default Square;
